<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";

  .history-section {
    display: flex;
    flex-direction: column;
    gap: utils.in_rem(12px);

    .title {
      @include mixins.body2();
      @include colors.color(primary_90);
      letter-spacing: utils.in_rem(0.325px);
      text-transform: uppercase;
    }

    .history-items {
      display: flex;
      flex-direction: column;
      gap: utils.in_rem(20px);
    }
  }
</style>

<script>
  import HistoryItem from "./HistoryItem.svelte";

  let { history = [], title, formatHistory } = $props();

  const wrappedFormatHistory = (x) => (formatHistory ? formatHistory(x) : {});
</script>

<div class="history-section">
  <span class="title">{title}</span>
  <div class="history-items">
    {#each history as item}
      <HistoryItem historyItem={wrappedFormatHistory(item)} />
    {/each}
  </div>
</div>
